'use strict';

import angular from 'angular';
import ActivateSuiteWebaccessController from './activate-suite-webaccess.controller';

export default angular.module('conduuApp.activateSuiteWebaccess', [])
  .controller('ActivateSuiteWebaccessController', ActivateSuiteWebaccessController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/activate-suite-webaccess/index.js